import React, { useEffect } from "react";
import { checkImage, getHexColor, setResponsiveImage } from "../../helpers";
import "./index.scss";

interface IButton {
  title: string;
  href: string;
  target: string;
}

interface ISchema {
  bgColor?: string;
  titleColor?: string;
  subTitleColor?: string;
  textColor?: string;
  buttonBgColor?: string;
  buttonTextColor?: string;
  bgGradient?: string;
}

interface IImage {
  cropKey: string;
  imageUrl: string | null;
}

interface Props {
  variant: string;
  image: IImage[];
  subTitle?: string;
  title: string;
  text?: string;
  button?: IButton;
  schema?: ISchema;
}

export default function OlympisCTA({
  variant = "Right",
  image,
  title,
  text,
  subTitle,
  button,
  schema
}: Props) {
  const KEY = Math.random()
    .toString(36)
    .slice(2);
  useEffect(() => {
    setResponsiveImage({
      mobileImage: checkImage({ images: image, size: "Small" }),
      tabletImage: checkImage({ images: image, size: "Medium" }),
      desktopImage: checkImage({ images: image, size: "Large" }),
      elClassName: `olympics-cta__image-${KEY}`
    });
  });

  const schemaColors: Record<string, string> = {
    "--schema-bgColor":
      schema && schema.bgGradient
        ? `radial-gradient(ellipse at bottom left, ${schema.bgColor} -60%, ${schema.bgGradient})`
        : schema && schema.bgColor
        ? getHexColor(schema.bgColor)
        : "var(--color-olympics-blue)",
    "--schema-subTitleColor":
      schema && schema.subTitleColor
        ? getHexColor(schema.subTitleColor)
        : "var(--color-white)",
    "--schema-titleColor":
      schema && schema.titleColor
        ? getHexColor(schema.titleColor)
        : "var(--color-white)",
    "--schema-textColor":
      schema && schema.textColor
        ? getHexColor(schema.textColor)
        : "var(--color-white)",
    "--schema-buttonBgColor":
      schema && schema.buttonBgColor
        ? getHexColor(schema.buttonBgColor)
        : "var(--color-white)",
    "--schema-buttonTextColor":
      schema && schema.buttonTextColor
        ? getHexColor(schema.buttonTextColor)
        : "var(--color-olympics-blue)"
  };
  return (
    <div
      className={`page-section olympics-cta-section${schema &&
        schema.bgGradient &&
        " theme version__2"}`}
    >
      <div className="page-section__inner">
        <div className={`olympics-cta variant-${variant}`} style={schemaColors}>
          <div
            className={`olympics-cta__image olympics-cta__image-${variant} olympics-cta__image-${KEY}`}
          />
          <div
            className={`olympics-cta__details${
              schema && schema.bgGradient && schema.bgGradient.length > 1
                ? " add-gradient"
                : ""
            }`}
          >
            {subTitle && (
              <div className="olympics-cta__subtitle">{subTitle}</div>
            )}
            <div className="olympics-cta__title">{title}</div>
            {text && (
              <div
                className="olympics-cta__text"
                dangerouslySetInnerHTML={{
                  __html: text
                }}
              />
            )}
            {button && (
              <div className="olympics-cta__button">
                <a href={button.href} target={button.target}>
                  {button.title}
                </a>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
